import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ConfigurationService {
  private readonly CONFIG_URL = environment.CONFIG_URL;

  private configuration: any;
  public configSubject$: Subject<any> = new Subject<any>();

  constructor(private http: HttpClient) {}

  public getConfiguration(): any {
    return this.configuration;
  }

  public loadConfigurations() {
    console.log("CONFIG_URL: " + JSON.stringify(this.CONFIG_URL));
    return this.http
      .get(this.CONFIG_URL)
      .toPromise()
      .then((config: any) => {
        this.configuration = config;
        console.log(" config: " + JSON.stringify(this.configuration));
        this.configSubject$.next(this.configuration);
      })
      .catch((err: any) => {
        console.error(err);
      });
  }
}
